class Controler {
  public selectElements(selector: string): NodeListOf<HTMLElement> {
    return document.querySelectorAll(selector);
  }
}

export default Controler;
